// Self-hosted typefaces. Only the weights the design tokens name — pulling a
// whole family would add several hundred kilobytes nothing renders with.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@fontsource/source-serif-4/400.css";
import "@fontsource/source-serif-4/600.css";
import "@fontsource/source-serif-4/700.css";

import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { initI18n } from "./lib/i18n.ts";
import { App } from "./App.tsx";
import "./styles/tokens.css";

initI18n();

const el = document.getElementById("root");
if (!el) throw new Error("eairi: #root not found");

const tree = <StrictMode><App /></StrictMode>;

// The marketing routes are prerendered to real HTML at build time. Where that
// markup is present, ADOPT it rather than replacing it: a fresh render would
// discard the server output and repaint, which is the flash a prerender exists
// to avoid. Everywhere else — every route behind sign-in — the root is empty
// and this is an ordinary client render.
if (el.hasChildNodes()) hydrateRoot(el, tree);
else createRoot(el).render(tree);
